import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../auth/AuthContext";
import "../styles/Profile.css";
import EditProfileForm from "../pages/EditProfileForm.jsx";
import CreateEventModal from "../pages/CreateEventModal.jsx";
import dayjs from 'dayjs';
import { useNavigate } from "react-router-dom";  
// import { CreateEventHook } from "../hooks/CreateEventHook.js";
import Navbar  from "../components/Navbar.jsx";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

function EventAddedPopup({ visible, onClose }) {
  useEffect(() => {
    if (visible) {
      const timer = setTimeout(onClose, 2000);
      return () => clearTimeout(timer);
    }
  }, [visible]);
  if (!visible) return null;
    

  return (
    <div className="popup-overlay">
      <div className="popup-card">
        <h3 className="popup-title">🎉 Event dodany!</h3>
        <p className="popup-text">Twój event został pomyślnie zapisany.</p>
        <button className="popup-btn" onClick={onClose}>
          OK
        </button>
      </div>
    </div>
  );
}

export default function Profile() {
  const { user, accessToken } = useContext(AuthContext);
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  // const { createEvent } = CreateEventHook();
  const [popupVisible, setPopupVisible] = useState(false);
  const [tab, setTab] = useState("my-events");
  const navigate = useNavigate();
  const [editingEvent, setEditingEvent] = useState(null);

  // ✅ Pobieramy TYLKO eventy użytkownika
  useEffect(() => {
    const fetchUserEvents = async () => {
      try {
        if (!user?.id) return;

        const res = await fetch(`${API_BASE}/api/events/by-user/${user.id}/?page=${page}`, {
          // headers: {
          //   Authorization: `Bearer ${accessToken}`
          // }
        });

        if (res.ok) {
          const data = await res.json();
          setEvents(data.results || data || []);
        }
      } catch (err) {
        console.error("Błąd ładowania wydarzeń:", err);
      } finally {
        setLoading(false);
      }
    };

    const fetchWatchedEvents = async () => {
      try {
        if (!user?.id) return;

        const headers = accessToken ? { Authorization: `Bearer ${accessToken}` } : undefined;
        const res = await fetch(`${API_BASE}/api/events/?is_watched=true&sort=soon`, { headers });

        if (res.ok) {
          const data = await res.json();
          setEvents(data.results || data || []);
        }
      } catch (err) {
        console.error("Błąd ładowania wydarzeń:", err);
      } finally {
        setLoading(false);
      }
    };
    if (tab === "my-events") fetchUserEvents();
    else if (tab === "watched") fetchWatchedEvents();
    // fetchUserEvents();
  }, [user, accessToken,tab]);

  if (!user) {
    return (
      <div className="text-center mt-5 text-muted fs-5">
        Musisz być zalogowany, aby zobaczyć swój profil.
      </div>
    );
  }


  return (
  <div className="profile-page">
    <Navbar variant="default" />

    {/* COVER (ograniczona szerokość) */}
    <div className="profile-cover-wrap">
      <div
        className="profile-cover"
        style={{
          "--cover-url": `url(${
            user.background_picture ||
            "https://wallpapers.com/images/featured/profile-background-b5vedq7mz8mjvslu.jpg"
          })`,
        }}
      />
    </div>

    {/* AVATAR (wyśrodkowany względem covera) */}
    <div className="profile-avatar-wrap">
      <div className="profile-avatar-inner">
        <img
          src={
            user.profile_picture ||
            "https://cdn-icons-png.flaticon.com/512/847/847969.png"
          }
          alt="Avatar"
          className="profile-avatar"
        />
      </div>
    </div>

    {/* INFO */}
    <div className="container text-center mt-4">
      <h2 className="fw-bold mb-1">{user.username}</h2>

      <p className="bio mt-3">{user.bio || "Brak opisu"}</p>

      <button
        className="btn btn-outline-primary rounded-pill mt-3 me-2"
        data-bs-toggle="modal"
        data-bs-target="#createEventModal"
      >
        <i className="bi bi-plus-lg me-2"></i> Dodaj wydarzenie
      </button>

      <button
        className="btn btn-outline-primary rounded-pill mt-3 me-2"
        data-bs-toggle="modal"
        data-bs-target="#editProfileModal"
      >
        <i className="bi bi-pencil me-2"></i> Edytuj profil
      </button>

      <button
        className="btn btn-outline-primary rounded-pill mt-3 me-2"
        onClick={() => navigate("/profile/settings")}
      >
        <i className="bi bi-gear me-2"></i> Ustawienia konta
      </button>
    </div>

    {/* EVENTS */}
    <div className="container mt-5">
      <ul className="nav nav-pills events-tabs mb-3">
        <li className="nav-item">
          <button
            type="button"
            className={`tab-pill ${
              tab === "my-events" ? "tab-pill--active" : ""
            }`}
            onClick={() => setTab("my-events")}
          >
            <i className="bi bi-calendar-event me-1" />
            Dodane wydarzenia
          </button>
        </li>
        <li className="nav-item">
          <button
            type="button"
            className={`tab-pill ${tab === "watched" ? "tab-pill--active" : ""}`}
            onClick={() => setTab("watched")}
          >
            <i className="bi bi-heart me-1" />
            Obserwowane
          </button>
        </li>
      </ul>

      {loading ? (
        <div className="text-center py-5">Ładowanie wydarzeń...</div>
      ) : events.length === 0 ? (
        <div className="text-center py-5 text-muted">
          Nie dodałeś jeszcze żadnych wydarzeń.
        </div>
      ) : (
        <div className="row g-4">
          {events.map((e) => (
            <div key={e.id} className="col-md-4 col-sm-6">
              <div
                className="card event-card border-0 shadow-sm"
                role="button"
                onClick={() => navigate(`/event/${e.id}`)}
              >
                <div
                  className="cover"
                  style={{
                    backgroundImage: `url(${
                      e.image ||
                      "https://images.unsplash.com/photo-1506784983877-45594efa4cbe?auto=format&fit=crop&w=1200&q=80"
                    })`,
                  }}
                />
                <div className="card-body">
                  <h6 className="fw-semibold">{e.name}</h6>

                  <div className="meta-item d-flex align-items-center">
                    <i className="bi bi-geo-alt me-1 text-primary"></i>
                    <span>{e.venue_name}</span>
                  </div>

                  <p className="small text-muted">
                    <i className="bi bi-calendar-event me-1 text-primary"></i>{" "}
                    {dayjs(e.start_datetime).format("YYYY-MM-DD HH:mm") || ""}
                  </p>

                  <p>
                    {e.category_names
                      .filter((t) => t !== e.primary)
                      .map((t) => (
                        <span key={t} className="badge text-bg-primary text-white px-2 py-1 rounded-pill">
                          {t}
                        </span>
                      ))}
                  </p>

                  {user.is_superuser && (
                    <button
                      className="btn btn-outline-primary btn-sm mt-2"
                      data-bs-toggle="modal"
                      data-bs-target="#editEventModal"
                      onClick={(ev) => {
                        ev.stopPropagation();
                        setEditingEvent(e);
                      }}
                    >
                      Edytuj wydarzenie
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>

    {/* MODALS */}
    <div className="modal fade" id="editProfileModal" tabIndex="-1" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content glass border-0 p-3">
          <div className="modal-header border-0">
            <h5 className="modal-title fw-semibold">
              <i className="bi bi-pencil-square me-2"></i> Edytuj profil
            </h5>
            <button className="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div className="modal-body">
            <EditProfileForm />
          </div>
        </div>
      </div>
    </div>

    <CreateEventModal
      mode="create"
      modalId="createEventModal"
      onSuccess={() => {
        setPopupVisible(true);
        setTimeout(() => window.location.reload(), 1200);
      }}
    />

    <EventAddedPopup
      visible={popupVisible}
      onClose={() => window.location.reload()}
    />

    <CreateEventModal
      mode="edit"
      eventId={editingEvent?.id}
      initialData={editingEvent}
      modalId="editEventModal"
      onSuccess={() => {
        setPopupVisible(true);
        setTimeout(() => window.location.reload(), 1200);
      }}
    />
  </div>
);

}
